import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../lib/api';

export const useSnapshots = (timePeriod) => {
  const [snapshots, setSnapshots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSnapshots = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      let startDate = null;
      if (timePeriod !== 'all') {
        const days = parseInt(timePeriod);
        const date = new Date();
        date.setDate(date.getDate() - days);
        startDate = date.toISOString().split('T')[0];
      }

      const params = {};
      if (startDate) {
        params.startDate = startDate;
      }

      const response = await axios.get(`${API_BASE_URL}/snapshots`, {
        params,
        withCredentials: true
      });

      setSnapshots(response.data.snapshots || []);
    } catch (err) {
      console.error('Error fetching snapshots:', err);
      setError(err.response?.data?.error || 'Failed to load snapshots');
    } finally {
      setLoading(false);
    }
  }, [timePeriod]);

  const refresh = useCallback(() => {
    fetchSnapshots();
  }, [fetchSnapshots]);

  useEffect(() => {
    fetchSnapshots();
  }, [fetchSnapshots]);

  return { snapshots, loading, error, refresh };
};
